export default __webpack_public_path__ + "static/avatar-smile-7b611c795c8ff5848180781f104d718c.png";